import React from 'react'
import CONSTANTS from '../../constants'

import './footer.css'

const PageFooter = ({props}) => {
  const { step } = props.store || ''
  const path = window.location.pathname
  // Initializing Layer
  const _LabelByStep = () => {
    switch(step){
      case 1 :
        return <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.dealer_locator_footer }} />
      case 2 :
        return <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.multislots_footer }} />
      case 3 :
        return <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.vehicule_footer }} />
      case 4 :
        return <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.needs_footer }} />
      case 5 :
        return <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.userinfos_footer }} />
      case 6 :
        return path !== CONSTANTS.SITE_ROUTS.CONFIRMATION ? <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.summary_footer }} /> : <div id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.confirm_footer }} />
      default :
        return path == CONSTANTS.SITE_ROUTS.CONFIRMATION ? <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.confirm_footer }} /> : ''
    }
  }
  return (
    <footer>
      <div tabIndex="0" id='legal' dangerouslySetInnerHTML={{ __html: CONSTANTS.SITE_INFO.GDPR }} />
      {_LabelByStep()}
    </footer>
  )
}

export default PageFooter
